var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaunchpadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8786 15.3714V20.6414C10.8786 20.9614 11.2686 21.1214 11.4886 20.8914L15.2086 18.2114C15.2786 18.1414 15.3086 18.0514 15.3086 17.9614V12.6614L18.9486 9.0214C19.9886 7.9814 20.2886 6.09139 20.2886 6.09139L20.9686 2.3314C21.1086 1.5314 20.4586 0.871398 19.6586 1.0214L16.0586 1.67139C16.0586 1.67139 14.0386 1.95139 12.9586 3.03139L9.32857 6.65139H4.03857C3.94857 6.65139 3.84857 6.69139 3.78857 6.75139L1.10857 10.4714C0.878566 10.7014 1.03857 11.0814 1.35857 11.0814H6.62857",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7485 11.2515L5.73853 16.2615",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchpadIcon);
export default __webpack_public_path__ + "static/media/launchpadIcon.87a89ff6b3d16fd6b534d5509eef8003.svg";
export { ForwardRef as ReactComponent };